"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_OPENABLE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var noop = function noop() {};

var DEFAULT_OPENABLE = 'openable';
exports.DEFAULT_OPENABLE = DEFAULT_OPENABLE;

var getInitialState = function getInitialState(openables) {
  return openables.reduce(function (acc, openable) {
    acc[openable] = {
      open: false,
      anchorEl: null
    };
    return acc;
  }, {});
};

var withOpenability = function withOpenability() {
  for (var _len = arguments.length, definedOpenables = new Array(_len), _key = 0; _key < _len; _key++) {
    definedOpenables[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var _class, _temp;

    var isOpenablesDefined = definedOpenables.length > 0;
    var openables = isOpenablesDefined ? definedOpenables : [DEFAULT_OPENABLE];
    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, _class);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", getInitialState(openables));

        _defineProperty(_assertThisInitialized(_this), "handleOpen", function (openable) {
          return function (event) {
            var _ref = event || {},
                _ref$currentTarget = _ref.currentTarget,
                currentTarget = _ref$currentTarget === void 0 ? null : _ref$currentTarget;

            _this.setState(_defineProperty({}, openable, {
              anchorEl: currentTarget,
              open: true
            }), function () {
              return _this.props.onOpen(openable);
            });
          };
        });

        _defineProperty(_assertThisInitialized(_this), "handleClose", function (openable) {
          return function () {
            _this.setState(_defineProperty({}, openable, {
              anchorEl: null,
              open: false
            }), function () {
              return _this.props.onClose(openable);
            });
          };
        });

        _defineProperty(_assertThisInitialized(_this), "handleToggle", function (openable) {
          return function (event) {
            var _ref2 = event || {},
                _ref2$currentTarget = _ref2.currentTarget,
                currentTarget = _ref2$currentTarget === void 0 ? null : _ref2$currentTarget;

            _this.setState(function (prevState) {
              return _defineProperty({}, openable, {
                anchorEl: prevState[openable].open ? null : currentTarget,
                open: !prevState[openable].open
              });
            }, function () {
              return _this.props.onToggle(openable);
            });
          };
        });

        return _this;
      }

      _createClass(_class, [{
        key: "getOpenables",
        value: function getOpenables() {
          var _this2 = this;

          return openables.reduce(function (acc, openable) {
            if (!_this2.handlers) {
              _this2.handlers = _this2.getHandlers();
            }

            acc[openable] = _objectSpread({}, _this2.handlers[openable], {}, _this2.state[openable]);
            return acc;
          }, {});
        }
      }, {
        key: "getHandlers",
        value: function getHandlers() {
          var _this3 = this;

          return openables.reduce(function (acc, openable) {
            acc[openable] = {
              handleOpen: _this3.handleOpen(openable),
              handleClose: _this3.handleClose(openable),
              handleToggle: _this3.handleToggle(openable)
            };
            return acc;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              onOpen = _this$props.onOpen,
              onClose = _this$props.onClose,
              onToggle = _this$props.onToggle,
              rest = _objectWithoutProperties(_this$props, ["onOpen", "onClose", "onToggle"]);

          return _react.default.createElement(WrappedComponent, _extends({}, rest, this.getOpenables()));
        }
      }]);

      return _class;
    }(_react.Component), _defineProperty(_class, "propTypes", {
      onClose: _propTypes.func,
      onOpen: _propTypes.func,
      onToggle: _propTypes.func
    }), _defineProperty(_class, "defaultProps", {
      onOpen: noop,
      onClose: noop,
      onToggle: noop
    }), _temp;
  };
};

var _default = withOpenability;
exports.default = _default;